import usePrivateAxios from '@/common/api/usePrivateAxios'
import { PublicCompanyLeadsFunnelUpdateValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePublicCompanyLeadMasterUser {
  publicCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useUpdatePublicCompanyLeadMasterUser = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadMasterUser) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updatePublicCompanyLeadMasterUser'],
    mutationFn: async (data: PublicCompanyLeadsFunnelUpdateValidationSchema) => {
      const lead = {
        contact_for_master_user_id: data.contact_for_master_user?.value,
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
